import { useQuery } from 'react-query';
import { weekCommitmentService } from '../../../../services';
import { useRef } from 'react';
import { trackingEvent } from '../../../../analytics';
import { AMPLITUDE_SERVICE } from '../../../../analytics/constants';
import { getBasicAmplitudEventProperties } from '../../../../analytics/utils';

export const useGetDefaultWeeklyPlan = ({ projectId, scheduleId }) => {
  const previousScheduleIdRef = useRef(scheduleId);
  const isInitialMount = useRef(true);
  const shouldExecute =
    isInitialMount.current || scheduleId !== previousScheduleIdRef.current;
  if (shouldExecute) {
    previousScheduleIdRef.current = scheduleId;
    isInitialMount.current = false;
  }
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['defaultWeeklyPlan', { projectId, scheduleId }],
    queryFn: async () => {
      const response = await weekCommitmentService.getCurrentWeeklyPlan({
        projectId,
        scheduleId
      });
      if (shouldExecute) {
        trackingEvent(
          'weekly_plan_viewed',
          {
            ...getBasicAmplitudEventProperties()
          },
          AMPLITUDE_SERVICE
        );
      }
      return response;
    },
    cacheTime: 0,
    enabled: shouldExecute,
    retry: false
  });

  return {
    data,
    isLoading,
    isError,
    error
  };
};
